import { render, staticRenderFns } from "./UploadOption.vue?vue&type=template&id=2d8e0356&scoped=true"
import script from "./UploadOption.vue?vue&type=script&lang=js"
export * from "./UploadOption.vue?vue&type=script&lang=js"
import style0 from "./UploadOption.vue?vue&type=style&index=0&id=2d8e0356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8e0356",
  null
  
)

export default component.exports